import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import styles from "./ForgotPassword.module.scss"; // Import SCSS module
import { Link } from "react-router-dom";
import { auth } from "../../services/firebaseConfig";
import { TextField } from "@mui/material";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent. Check your inbox.");
    } catch (error) {
      setError(error.message);
    }

    setLoading(false);
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.leftSection}>
        {/* TODO: Change image url */}
        <img
          src="https://res.cloudinary.com/daojypjrh/image/upload/logo.jpg"
          alt="JainGlory Foundation"
        />
      </div>

      <div className={styles.rightSection}>
        <div className={styles.formBox}>
          <div className={styles.formHeader}>
            <h1>JainGlory Foundation Admin Panel</h1>
            <h2>Forgot Password</h2>
            {error ? <span className={styles.error}>{error}</span> : null}
          </div>

          <div className={styles.formBody}>
            <form onSubmit={handlePasswordReset}>
              <TextField
                fullWidth
                className={styles.inputField}
                type="email"
                placeholder="Enter your email"
                variant="outlined"
                size="small"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              {message ? (
                <div className={styles.mailSentMessage}>{message}</div>
              ) : (
                <button type="submit" disabled={loading}>
                  {loading ? "Sending..." : "Reset Password"}
                </button>
              )}

              <div className={styles.backToLogin}>
                <Link to="/" className={styles.loginPageLink}>
                  Back to Login
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
